import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function HowItWorks() {
  const steps = [{
    number: '01',
    text: 'Descargás el manual y realizás tu autodiagnóstico de inflamación.'
  }, {
    number: '02',
    text: 'Aplicás la "Regla del Plato Metabólico" y el orden de ingesta en tus comidas actuales.'
  }, {
    number: '03',
    text: 'Seguís el plan de 21 días para reprogramar tu respuesta hormonal y recuperar tu vitalidad.'
  }];
  return <section className="py-24 bg-brand-cream relative" data-id="element-106">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-107">
        <FadeIn data-id="element-108">
          <div className="text-center mb-16" data-id="element-109">
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-charcoal mb-4" data-id="element-110">
              ¿Cómo funciona?
            </h2>
            <p className="text-gray-600 text-lg" data-id="element-111">
              Un proceso simple, diseñado para mujeres reales con poco tiempo.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-8 mb-16 relative" data-id="element-112">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute left-12 top-12 bottom-12 w-0.5 bg-brand-orange/20 z-0" data-id="element-113"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={0.2 * index} direction="up" data-id="element-114">
              <div className="relative z-10 flex flex-col md:flex-row items-start md:items-center gap-6 bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-brand-orange/10 hover:shadow-md transition-shadow" data-id="element-115">
                <div className="flex-shrink-0 w-16 h-16 md:w-24 md:h-24 bg-brand-orange text-white rounded-2xl flex items-center justify-center font-serif text-2xl md:text-4xl font-bold shadow-inner" data-id="element-116">
                  {step.number}
                </div>
                <p className="text-lg md:text-xl text-gray-700 font-medium leading-relaxed" data-id="element-117">
                  {step.text}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} className="text-center" data-id="element-118">
          <CTAButton data-id="element-119" />
        </FadeIn>
      </div>
    </section>;
}